import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvanoToasterComponent } from './avano-toaster/avano-toaster.component';
import { MessageService } from 'primeng/api';
import { AvanoDirectivesModule } from '../directives/avano-directives.module';
import { ToastModule } from 'primeng/toast';
import { AvanoButtonModule } from '../avano-button/avano-button.module';



@NgModule({
  declarations: [AvanoToasterComponent],
  imports: [
    CommonModule,
    ToastModule,
    AvanoDirectivesModule,
    AvanoButtonModule,
  ], exports: [
    AvanoToasterComponent
  ],
  providers: [
    MessageService,
  ]
})
export class AvanoFeedbackModule { }
